import React from 'react';
import { CtaButton } from '../CtaButton';
import { Countdown } from '../Countdown';
import { ScarcityBar } from '../ScarcityBar';
export function FinalCta() {
  return <section className="w-full bg-navy-800" data-id="element-150" data-mp="22fp4ahkhwles">
      <div className="mx-auto w-full max-w-3xl px-5 py-14 sm:px-8 sm:py-20" data-id="element-151" data-mp="1nnydcxf2pvmv">
        <h2 className="text-center font-display text-[27px] font-extrabold leading-tight text-white sm:text-4xl" data-id="element-152" data-mp="1snj96yyy5nvd">
          La próxima vez que un paciente llegue con una creatinina elevada…
        </h2>
        <p className="mt-4 text-center text-[15px] leading-relaxed text-cream-100/80 sm:text-lg" data-id="element-153" data-mp="1iqeoz4onw2h7">
          Tendrás dos opciones.
        </p>

        <div className="mt-7 grid grid-cols-1 gap-3.5 sm:grid-cols-2" data-id="element-154" data-mp="14ryh3af2c5xh">
          <div className="rounded-2xl border border-white/10 bg-navy-900/60 p-5" data-id="element-155" data-mp="19q9o7ddz42c0">
            <p className="text-[11px] font-extrabold uppercase tracking-[0.14em] text-alert-500" data-id="element-156" data-mp="2z3mw1clao8hv">
              Opción 1
            </p>
            <p className="mt-2 text-[14px] leading-relaxed text-cream-100/80" data-id="element-157" data-mp="342puufaolihe">
              Seguir buscando respuestas entre múltiples guías y tomar decisiones con incertidumbre.
            </p>
          </div>
          <div className="rounded-2xl border-2 border-renal-500 bg-renal-600/15 p-5" data-id="element-158" data-mp="3tf621taoy73s">
            <p className="text-[11px] font-extrabold uppercase tracking-[0.14em] text-renal-400" data-id="element-159" data-mp="b0x4k4b1r2qy">
              Opción 2
            </p>
            <p className="mt-2 text-[14px] font-semibold leading-relaxed text-white" data-id="element-160" data-mp="3ffn57wnbyi6s">
              Abrir Ruta Enfermedad Renal™ y saber exactamente cuál es el siguiente paso.
            </p>
          </div>
        </div>

        <div className="mt-8" data-id="element-161" data-mp="3ogurfgcknski">
          <CtaButton size="lg" label="Quiero acceder ahora a la Ruta Renal™" sub="Descarga inmediata • Pago único • Acceso de por vida • Garantía de 7 días" data-id="element-162" data-mp="3ohwdsgz1g1hj" />
        </div>

        <div className="mt-7 rounded-3xl bg-white/95 px-4 py-6 sm:px-6" data-id="element-163" data-mp="13s7047a2mlqf">
          <Countdown data-id="element-164" data-mp="yq7wcwaf5msy" />
          <div className="mt-5" data-id="element-165" data-mp="yqras30v1t28">
            <ScarcityBar data-id="element-166" data-mp="3sj96c9n8u24x" />
          </div>
        </div>

        <footer className="mt-10 border-t border-white/10 pt-6 text-center" data-id="element-167" data-mp="3sipoesxlfdqw">
          <p className="font-display text-base font-bold text-white" data-id="element-168" data-mp="1bd62akz4u9e">
            Dra. <span className="text-renal-400" data-id="element-169" data-mp="5drrn2g1284d">Karito</span>
          </p>
          <p className="mt-2 text-[11.5px] leading-relaxed text-cream-100/50" data-id="element-170" data-mp="5cgi0lzwi65c">
            Ruta Enfermedad Renal™ — Material educativo dirigido a profesionales de la salud. No
            sustituye el juicio clínico individual ni la relación médico-paciente.
          </p>
          <p className="mt-3 text-[11px] text-cream-100/40" data-id="element-171" data-mp="3ducr9smrrout">
            © {new Date().getFullYear()} Dra. Karito. Todos los derechos reservados.
          </p>
        </footer>
      </div>
    </section>;
}